<!--
 * @Description: 
 * @Version: 2.0
 * @Author: Zed
 * @Date: 2020-10-10 13:47:16
 * @LastEditors: Zed
 * @LastEditTime: 2020-10-13 11:12:45
-->
<template>
  <div>
    <el-table :data="list" :show-header="!hideHeader" style="width: 100%" @row-click="onInfo">
       <el-table-column  width="30px" :show-overflow-tooltip="true"  prop="title">
        <template slot-scope="scope">
          <img src="@/assets/images/law.png" height="20"  alt="" srcset="" class="concatItem">
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="政策标题" prop="title">
        <template slot-scope="scope">
          <a href="javascript:;" class='sucess'>{{ scope.row.title }}</a>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="政策摘要" prop="summary" v-if="!hideHeader">
        <template slot-scope="scope">
          <a href="javascript:;" class='sucess'>{{ scope.row.summary }}</a>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="创建日期" prop="createTime" width="180">
        <template slot-scope="scope">
          <div class="release-time">{{ scope.row.createTime }}</div>
        </template>
      </el-table-column>
      <div slot="empty" class="empty">
        <el-empty description="暂无数据" />
      </div>
    </el-table>
  </div>

</template>

<script>
export default {
  props: {
    list: Array,
    hideHeader: Boolean,
  },
  methods:{
    onInfo(row){
      this.$router.push({
        path:"/detail",
        query:{
          id: row.id,
          type: 3,
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.release-time {
  color: #999999;
  font-size: 16px !important;
  tr{
    cursor: pointer;
  }
  
}
 .el-table tr {
    background-color: #fff!important;
    cursor: pointer!important;
}

  .info{
    color:#C0C4CC ;
    text-decoration: none;
  }
  .sucess{
    color:#131313 ;
    text-decoration: none;
    font-size: 16px;
  }
</style>